import { useAppDispatch } from 'state/store';
import { setToken, setUserEmail } from 'state/store/reducers/authSlice';

export type UseAuthActions = {
  setToken: (token: string) => void;
  setUserEmail: (email: string) => void;
};

export const useAuthActions = (): UseAuthActions => {
  const dispatch = useAppDispatch();

  return {
    setToken: (token: string) => {
      dispatch(setToken(token));
    },
    setUserEmail: (email: string) => {
      dispatch(setUserEmail(email));
    },
  };
};
